import styled from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledAccordion = styled.div`
  ${tw`tw-rounded-lg tw-overflow-hidden tw-border-solid tw-border tw-border-border-primary tw-border-b-0`}
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledAccordion.displayName = "StyledAccordion";

export const StyledAccordionItem = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--page-paper-main);
  border: 1px solid transparent;
  border-bottom: 1px solid var(--border-primary);
  overflow: hidden;
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledAccordionItem.displayName = "StyledAccordionItem";

export const StyledAccordionItemBody = styled.div`
  margin: 0 16px;
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledAccordionItemBody.displayName = "StyledAccordionItemHead";

export const StyledAccordionItemHead = styled.div`
  user-select: none;
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: var(--color-theme-900);
  cursor: pointer;
  ${FontStyle}
  ${BoxSizingStyle}
  .text {
    font-weight: bold;
    font-size: 13px;
  }
  .icon {
    width: 16px;
    height: 16px;
    fill: currentColor;
    transform: translateY(-4px);
  }
`;

StyledAccordionItemHead.displayName = "StyledAccordionItemHead";

export const StyledAccordionItemHeadText = styled.div`
  font-weight: bold;
  font-size: 13px;
`;

StyledAccordionItemHeadText.displayName = "StyledAccordionItemHeadText";

export const StyledAccordionItemHeadIcon = styled.div`
  width: 16px;
  height: 16px;
  fill: currentColor;
  transform: translateY(-4px);
`;

StyledAccordionItemHeadIcon.displayName = "StyledAccordionItemHeadIcon";
